import React, { Component, Fragment } from "react"
import { hotkeys } from "react-keyboard-shortcuts"
import { cloneDeep } from "lodash"
// import PropTypes from "prop-types"
import {
    BlockContextProvider,
    query as queryProvider,
    url as urlProvider,
} from "./ContextProviders"
import { withRouter } from "react-router"
import RenderTree from "./RenderTree"
import Sidebar from "./Sidebar"
import BroadcastContext from "./broadcast/Context"
import { DragDropContext } from "./dnd/Context"
import ValueStore from "./properties/ValueStore"
import "./styles.css"
// import treeSelector from "./tree"
import { fetchAndReturn, acceptHeaders } from "data/utils/utils"

import { Frame, PageContentArea } from "./ui/Frame"
import LeftSidebar from "./sidebars/LeftSidebar"
import RightSidebar from "./sidebars/RightSidebar"
import HeaderBar from "./sidebars/HeaderBar"
import FooterBar from "./sidebars/FooterBar"
import { ThemeProvider } from "emotion-theming"
import stackerTheme from "ui/styleHelpers/stackerTheme"
import stackerDarkTheme from "ui/styleHelpers/stackerDarkTheme"

const queryString = require("qs")
const html2canvas = require("html2canvas")
window.html2canvas = html2canvas

/**
 * @augments {Component<{tree: TreeInstanceType, allowEdits?:boolean, page, save?}>}
 */
class page extends Component {
    /**
     * @type {Partial<BlockContext>} state
     */
    state = {
        // not really used yet, can be of any shape
        user: {
            id: "user_01",
        },

        // do not update here
        // this is used at a nested level, defined automatically by every block, making it easy to access the current block id
        // for example inside <DefineProperty/>
        block: null,

        // can be one of "mobile" | "desktop" | "tablet"
        // implementation is not complete
        // in theory, in your block config' style, you can do:
        // block.config.style = {
        //    default: { background: red},
        //    mobile: {background: pink},
        //    tablet: {color: blue},
        //    desktop: {color: green}
        // }
        deviceType: window.innerWidth > 768 ? "desktop" : "mobile",

        // updated by our ContainerBlockType, it's required by our drag/drop implementation
        direction: "row",

        // not currently used, made for data blocks
        url: null,
        // not currently used, made for data blocks
        query: null,

        // set of various actions available anywhere in the tree, this probably shouldn't be here
        actions: {
            // block.onClick
            selectBlock: blockId => {
                if (!this.state.editor.isEditing) {
                    return
                }

                if (this.state.editor.selected == blockId) {
                    return
                }

                if (this.state.editor.isFormatPainting) {
                    this.props.tree.updateBlockStyles(blockId, this.state.editor.formatPaintStyles)
                }

                const parentBlockId = this.props.tree.parentBlocks[blockId]

                this.setState(({ editor }) => ({
                    editor: {
                        ...editor,
                        selected: blockId,
                        selectedParent: parentBlockId,
                        selectedBlock: this.props.tree.indexedBlocks[blockId],
                        isFormatPainting: false,
                    },
                }))
            },
            copySelected: () => {
                const selectedID = this.state.editor.selected
                if (!selectedID) return false
                console.log(JSON.stringify(this.props.tree.indexedBlocks[selectedID], null, 2))

                const copy = JSON.stringify(this.props.tree.indexedBlocks[selectedID])
                localStorage.setItem("clipboard", copy)
            },
            cutSelected: () => {
                if (this.state.cutting) return
                const selectedID = this.state.editor.selected
                if (!selectedID) return false
                const copy = JSON.stringify(this.props.tree.indexedBlocks[selectedID])

                localStorage.setItem("clipboard", copy)

                const tree = this.props.tree
                tree.recordHistory()

                this.setState({ cutting: true }, () => {
                    this.setState(
                        ({ editor }) => ({
                            cutting: false,

                            editor: {
                                ...editor,
                                selected: null,
                            },
                        }),
                        this.state.actions.removeBlock(selectedID)
                    )
                })
            },
            pasteAtSelected: () => {
                // Debounce the paste!
                if (this.state.pasting) return

                const tree = this.props.tree
                tree.recordHistory()
                const blockToPaste = JSON.parse(localStorage.getItem("clipboard"))
                if (!blockToPaste) return false

                // Find the target from the current block
                let pasteTarget
                const selectedID = this.state.editor.selected
                if (!selectedID) return false
                this.setState({ pasting: true }, () => {
                    const selectedBlock = tree.indexedBlocks[selectedID]

                    if (
                        ["container", "card", "form", "record_data", "modal"].indexOf(
                            selectedBlock.type
                        ) >= 0
                    ) {
                        pasteTarget = selectedBlock
                    } else pasteTarget = tree.indexedBlocks[tree.parentBlocks[selectedBlock.id]]
                    tree.createAndAddBlock(
                        blockToPaste,
                        pasteTarget.id,
                        pasteTarget.childBlocks.length
                    )

                    // Re-clone so that the next object doesn't share properties
                    this.setState(({ editor }) => ({
                        pasting: false,
                        editor: {
                            ...editor,
                            clipboard: cloneDeep(editor.clipboard),
                        },
                    }))
                })
            },
            formatPaintFromSelected: () => {
                const selectedID = this.state.editor.selected
                if (!selectedID) return false
                this.setState(({ editor }) => ({
                    editor: {
                        ...editor,
                        formatPaintStyles: cloneDeep(
                            this.props.tree.indexedBlocks[selectedID].config.style
                        ),
                        isFormatPainting: true,
                    },
                }))
            },
            removeBlock: blockId => {
                const tree = this.props.tree
                tree.recordHistory()
                tree.removeBlock(blockId)

                tree.updateTree(tree.tree)
            },
            removeSelected: () => {
                const selectedID = this.state.editor.selected
                if (!selectedID) return false

                this.state.actions.removeBlock(selectedID)
            },
            undo: () => {
                if (this.state.undoing) return
                this.setState({ undoing: true }, () => {
                    this.props.tree.undo()
                    this.setState({ undoing: false })
                })
            },

            // update a block's attribute
            updateAttributes: (id, key, value) => {
                const tree = this.props.tree
                tree.recordHistory()
                tree.updateBlockAttributes(id, key, value)
                console.log("going to update attributes:", id, key, value)
            },

            // update a style's attribute
            // not sure how this works with our different devices ( "mobile" | "desktop" | "tablet" )
            updateStyle: (id, key, value) => {
                const tree = this.props.tree
                tree.recordHistory()
                tree.updateBlockStyle(id, key, value, this.state.deviceType)
                console.log(
                    "going to update styles for block",
                    id,
                    key,
                    value,
                    this.state.deviceType
                )
            },

            // link a broadcast object to a block, accessible from block.config.broadcast
            // done automatically from within DefineBroadcast
            // if you want to create a discoverable broadcast, this isn't the place to do it
            addBroadcast: (id, value) => {
                const tree = this.props.tree
                tree.addBroadcast(id, value)
            },

            // remove broadcast from a block, but not from the context
            // check out DefineBroadcast for more infos
            removeBroadcast: (id, value) => {
                const tree = this.props.tree
                tree.removeBroadcast(id, value)
            },

            // used to update a broadcast's published_name
            updateBroadcast: (id, value) => {
                const tree = this.props.tree
                tree.updateBroadcast(id, value)
            },

            // add a green border around the selected block
            highlightElement: id => {
                this.secondStyleNode.innerHTML = `
                .isEditing .block-${id}:not(.isDragging):not(.isHovered) {
                    border: 1px dashed green !important;
                }
                `
            },
            stopHighlight: () => {
                this.secondStyleNode.innerHTML = ``
            },
            viewDesktop: () => {
                this.setState({
                    deviceType: "desktop",
                })
            },
            viewMobile: () => {
                this.setState({
                    deviceType: "mobile",
                })
            },

            // orange border
            onHover: id => {
                if (this.hoveredElement === id) {
                    return
                }
                this.hoveredElement = id

                this.styleNode.innerHTML = `
                .isEditing .block-${id}:hover:not(.isDragging):not(.isHovered) {
                    outline: 1px dashed orange !important;
                }
                .isEditing .block-${id}:hover:not(.isDragging):not(.isHovered) > .block-name {
                    display: block;
                    background: none;
                    color: orange;
                    border: 1px orange solid;
                }
                `
            },

            captureScreenshot: () => {
                import("html2canvas").then(html2canvas => {
                    html2canvas(document.getElementById("page"), {
                        dpi: 300,
                    }).then(canvas => {
                        console.log(canvas.toDataURL())

                        fetchAndReturn(`thumbnails/${this.props.page._sid}/`, {
                            method: "POST",
                            headers: acceptHeaders,
                            body: JSON.stringify({ image: canvas.toDataURL() }),
                        })
                    })
                })
            },
        },
        editor: {
            // if you want to disable the modifications, d&d, ... this is the property to change
            isEditing: this.props.allowEdits,

            // current selected block
            selected: null,

            // Page we're on
            page: this.props.page,

            // clearly shouldn't be here
            // deal with tree updates when dropping a (new or existing) block
            onDrop: ({ dragPayload, dropPayload, position }) => {
                const instance = this.props.tree
                let newBlock = dragPayload.blockElement
                let template = dragPayload.blockTemplate || {}

                if (newBlock) {
                    newBlock = {
                        type: dragPayload.id.replace("template_", ""),
                        config: {
                            attributes: {},
                            style: {},
                            broadcast: [],
                            ...cloneDeep(dragPayload.defaultConfig),
                        },
                        childBlocks: [],
                        ...template,
                    }
                }

                if (!position || position === "none" || dropPayload.id === "page") {
                    if (newBlock) {
                        instance.recordHistory()
                        const newBlockInstance = instance.createAndAddBlock(
                            newBlock,
                            dropPayload.id,
                            dropPayload.position
                        )

                        return this.state.actions.selectBlock(newBlockInstance.id)
                    }
                    instance.recordHistory()
                    return instance.moveBlock(dragPayload.id, dropPayload.id, dropPayload.position)
                }
                const target = instance.indexedBlocks[dropPayload.id]
                const parentId = instance.parentBlocks[dropPayload.id]
                const parent = instance.indexedBlocks[parentId]
                const containerPosition = instance.indexedBlocks[parentId].childBlocks.indexOf(
                    target
                )

                // moving into same container, with only itself as child
                if (!newBlock) {
                    const blockParentId = instance.parentBlocks[dropPayload.id]

                    if (parentId === blockParentId && parent.childBlocks.length === 1) return
                }

                instance.recordHistory()

                const newContainerBlock = instance.createAndAddBlock(
                    {
                        type: "container",
                        config: {
                            attributes: {
                                direction: dropPayload.direction === "column" ? "row" : "column",
                            },
                            style: {
                                default: { width: "100%", flexWrap: "nowrap" },
                            },
                        },
                        childBlocks: [],
                    },
                    parentId,
                    containerPosition
                )

                instance.moveBlock(dropPayload.id, newContainerBlock.id, 0)
                if (newBlock) {
                    const newBlockInstance = instance.createAndAddBlock(
                        newBlock,
                        newContainerBlock.id,
                        position === "left" || position === "top" ? 0 : 1
                    )

                    return this.state.actions.selectBlock(newBlockInstance.id)
                } else {
                    instance.moveBlock(
                        dragPayload.id,
                        newContainerBlock.id,
                        position === "left" || position === "top" ? 0 : 1
                    )
                }
            },
        },
    }
    componentDidMount() {
        console.log("MOUNTING")
        // used for orange and green borders
        this.styleNode = document.createElement("style")
        this.secondStyleNode = document.createElement("style")
        document.body.appendChild(this.styleNode)
        document.body.appendChild(this.secondStyleNode)

        // subscribe for tree changes
        this.unsubscribe = this.props.tree.subscribe(events => {
            // console.log("changes", events)
            this.forceUpdate()
        })
    }

    componentDidUpdate() {
        // console.log("UPDATED")
        this.unsubscribe = this.props.tree.subscribe(events => {
            // console.log("changes", events)
            this.forceUpdate()
        })
    }

    componentWillUnmount() {
        console.log("UNMOUNTING")
        this.styleNode.remove()
        this.secondStyleNode.remove()
        this.unsubscribe()
    }

    constructor(props) {
        super(props)
        this.state.editor.page = props.page || {}
    }

    componentWillReceiveProps(newProps) {
        this.setState({ editor: { ...this.state.editor, page: newProps.page || {} } })
    }

    render() {
        const userTheme = stackerTheme
        //
        const query = queryString.parse(this.props.location.search.slice(1)) // Slice to remove the "?"

        return (
            <BroadcastContext>
                <ValueStore>
                    <DragDropContext
                        onDrop={this.state.editor.onDrop}
                        debug={false}
                        isActive={this.state.editor.isEditing}
                    >
                        {dragDropContext => (
                            <BlockContextProvider
                                data={this.state}
                                dragDropContext={dragDropContext}
                                tree={this.props.tree.tree}
                            >
                                {/* YOUR CONTENT SHOULD BE IN THIS BLOCK */}
                                <ThemeProvider theme={stackerDarkTheme}>
                                    <Frame>
                                        {this.props.allowEdits && (
                                            <Fragment>
                                                <LeftSidebar
                                                    page={this.state.editor.page}
                                                    savePage={this.props.onChange}
                                                />
                                                <HeaderBar
                                                    undo={this.state.actions.undo}
                                                    save={() => {
                                                        //this.state.actions.captureScreenshot()
                                                        this.props.saveTree()
                                                    }}
                                                    copy={this.state.actions.copySelected}
                                                    paste={this.state.actions.pasteAtSelected}
                                                    formatPaint={
                                                        this.state.actions.formatPaintFromSelected
                                                    }
                                                    remove={this.state.actions.removeSelected}
                                                    viewDesktop={this.state.actions.viewDesktop}
                                                    viewMobile={this.state.actions.viewMobile}
                                                />
                                            </Fragment>
                                        )}
                                        <PageContentArea
                                            isFormatPainting={this.state.editor.isFormatPainting}
                                            editing={this.props.allowEdits}
                                        >
                                            <queryProvider.Provider value={query}>
                                                <urlProvider.Provider
                                                    value={this.props.urlCaptures}
                                                >
                                                    <ThemeProvider theme={userTheme}>
                                                        <div
                                                            id="page"
                                                            className="flex-1 display-flex"
                                                            style={{
                                                                minHeight: "100%",
                                                                margin: "0px auto",
                                                                padding: this.state.editor.isEditing
                                                                    ? "18px 18px 0px"
                                                                    : "none",
                                                                backgroundColor: "#454b58",
                                                                width:
                                                                    this.state.deviceType ===
                                                                        "mobile" &&
                                                                    window.innerWidth > 768
                                                                        ? "320px"
                                                                        : "100%",
                                                            }}
                                                        >
                                                            <RenderTree
                                                                instance={this.props.tree}
                                                            />
                                                        </div>
                                                    </ThemeProvider>
                                                </urlProvider.Provider>
                                            </queryProvider.Provider>
                                        </PageContentArea>
                                        {this.props.allowEdits && (
                                            <Fragment>
                                                <FooterBar instance={this.props.tree} />
                                                <RightSidebar>
                                                    <Sidebar
                                                        setIsEditing={value =>
                                                            this.setState(({ editor }) => ({
                                                                editor: {
                                                                    ...editor,
                                                                    isEditing: value,
                                                                },
                                                            }))
                                                        }
                                                    />
                                                </RightSidebar>
                                            </Fragment>
                                        )}
                                    </Frame>
                                </ThemeProvider>
                            </BlockContextProvider>
                        )}
                    </DragDropContext>
                </ValueStore>
            </BroadcastContext>
        )
    }

    hot_keys = {
        "meta+z": {
            priority: 1,
            handler: event => {
                this.state.actions.undo()
            },
        },
        "meta+shift+s": {
            priority: 1,
            handler: event => {
                // this.state.actions.captureScreenshot()
                this.props.saveTree()
            },
        },
        "meta+x": {
            priority: 1,
            handler: event => {
                !isFocusedElementFormElement() && this.state.actions.cutSelected()
            },
        },
        "meta+c": {
            priority: 1,
            handler: event => {
                !isFocusedElementFormElement() && this.state.actions.copySelected()
            },
        },
        "meta+v": {
            priority: 1,
            handler: event => {
                !isFocusedElementFormElement() && this.state.actions.pasteAtSelected()
            },
        },
        "meta+shift+f": {
            priority: 1,
            handler: event => {
                this.state.actions.formatPaintFromSelected()
            },
        },
        backspace: {
            priority: 1,
            handler: event => {
                !isFocusedElementFormElement() && this.state.actions.removeSelected()
            },
        },
    }
}

function isFocusedElementFormElement() {
    const element = document.activeElement
    const type = element.nodeName

    const listOfFormElements = ["INPUT", "TEXTAREA"]

    if (listOfFormElements.indexOf(type) >= 0) return true

    if (element.isContentEditable) {
        return true
    }
}

page.propTypes = {}

const hotkeyPage = hotkeys(page)
const withRouterPage = withRouter(hotkeyPage)

export default withRouterPage



// WEBPACK FOOTER //
// ./src/features/editor/page.js